import React, { useState } from 'react';
import TourViewer from './TourViewer';
import { TOUR_ROOMS, TOUR_ROOM_IDS } from '../data/tourRooms';

const VirtualTourSection = ({ isModal = false }) => {
  const [currentRoom, setCurrentRoom] = useState('living');

  const handleRoomChange = (roomId) => {
    setCurrentRoom(roomId);
  };

  if (isModal) {
    return (
      <div className="min-h-screen bg-stone-900">
        <div className="h-screen w-full p-4">
          <TourViewer room={currentRoom} onRoomChange={handleRoomChange} />
        </div>
      </div>
    );
  }

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-16" style={{backgroundColor: '#F5EFE6'}}>
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 tracking-tighter" style={{color: '#3E3E3E'}}>
            Explore in 3D
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto" style={{color: '#7A7A7A'}}>
            Experience your dream space with our immersive virtual tours
          </p>
        </div>

        {/* 3D Tour Container */}
        <div className="relative bg-stone-900 rounded-2xl overflow-hidden shadow-2xl" style={{height: '600px'}}>
          <TourViewer room={currentRoom} onRoomChange={handleRoomChange} />
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
          <div className="text-center p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white text-2xl">360</span>
            </div>
            <h3 className="text-xl font-bold mb-3" style={{color: '#3E3E3E'}}>360° View</h3>
            <p style={{color: '#7A7A7A'}}>
              Explore every corner of our designs with complete panoramic views
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white text-2xl">touch_app</span>
            </div>
            <h3 className="text-xl font-bold mb-3" style={{color: '#3E3E3E'}}>Interactive</h3>
            <p style={{color: '#7A7A7A'}}>
              Drag, zoom, and navigate through spaces naturally and intuitively
            </p>
          </div>

          <div className="text-center p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow duration-300">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white text-2xl">fullscreen</span>
            </div>
            <h3 className="text-xl font-bold mb-3" style={{color: '#3E3E3E'}}>Immersive</h3>
            <p style={{color: '#7A7A7A'}}>
              Fullscreen mode for complete immersion in your future space
            </p>
          </div>
        </div>

        {/* Room Thumbnails */}
        <div className="mt-12 sm:mt-16">
          <h3 className="text-2xl font-bold text-center mb-8" style={{color: '#3E3E3E'}}>Explore Our Spaces</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {TOUR_ROOM_IDS.map((roomId) => {
              const room = TOUR_ROOMS[roomId];
              return (
              <button
                key={roomId}
                type="button"
                onClick={() => setCurrentRoom(roomId)}
                className={`p-4 rounded-xl border-2 transition-all duration-300 text-left ${
                  currentRoom === roomId
                    ? 'border-primary shadow-lg'
                    : 'border-stone-200 hover:border-stone-300'
                }`}
                style={{
                  borderColor: currentRoom === roomId ? '#C8A96A' : undefined
                }}
              >
                <img
                  src={room.image}
                  alt={room.name}
                  className="w-full h-20 object-cover rounded-lg mb-3"
                />
                <h4 className="font-semibold mb-1" style={{color: '#3E3E3E'}}>{room.name}</h4>
                <p className="text-sm text-stone-600 line-clamp-2">{room.description}</p>
              </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VirtualTourSection;
